import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import details from "../../assets/icon/details.png";

import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";

import {
  getEmpearningSalary,
  getUnpaidUser,
  viewPaymentSlip,
} from "../paymentReceipt/paymentReceiptApi";

import { useSelector } from "react-redux";
import { getAllEnquiriesById } from "../myInstitute/instituteApi";
import { getCompanyEnquiries } from "./whitelabelApi";
import CandidateInformation from "../MyFranchise/candidateInformation";
// import { getAllEnquiriesById } from "./instituteApi";

const Enquiries = ({ backEnquire, enquiries }) => {
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );
  const [enquiry, setenquiry] = useState();
  const [totalEnquiry, setTotalEnquiry] = useState();
  const [modalData, setModalData] = useState();
  const [open, setOpen] = useState(false);
  const getAllApplieded = async (param) => {
    const payload = {
      companyProductId: enquiries.id,
    };

    getCompanyEnquiries(payload, (data) => {
      console.log("enquiries ", data.data.data.list);
      const datalist = data.data;
      setenquiry(datalist.data.list);
      setTotalEnquiry(datalist.data.totalRecords);
    });
  };

  useEffect(() => {
    getAllApplieded();
  }, []);

  const tableGrid = {
    display: "grid",
    gridTemplateColumns: {
      lg: `
    minmax(140px, 1fr)  
    minmax(220px, 2fr)     
    minmax(160px, 1.5fr)   
    minmax(220px, 1.5fr)    
    minmax(260px, 2fr)     
    minmax(90px, 1fr)     
  `,
      md: `
  minmax(120px, 1.2fr)
  minmax(200px, 2fr)
  minmax(140px, 1.5fr)
  minmax(200px, 2fr)
  minmax(240px, 2fr)
  minmax(80px, 1fr)
  `,
      sm: `
  minmax(100px, 1.2fr)
  minmax(180px, 2fr)
  minmax(120px, 1.5fr)
  minmax(180px, 2fr)
  minmax(220px, 2fr)
  minmax(70px, 1fr)
  `,
      xs: `
  minmax(80px, 1.2fr)
  minmax(150px, 2fr)
  minmax(100px, 1.5fr)
  minmax(150px, 2fr)
  minmax(200px, 2fr)
  minmax(60px, 1fr)
  `,
    },
    alignItems: "center",
    columnGap: "12px",
  };
  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const label = {
    fontSize: {
      xs: "12px",
      sm: "13px",
      md: "14px",
      lg: "15px",
    },
  };

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container spacing={{ xs: 1, sm: 2 }}>
          <IconButton
            onClick={() => backEnquire()}
            sx={{
              "&:hover": {
                backgroundColor: "transparent", // removes hover background
              },
            }}
            // sx={{
            //   color: "#01008B",
            //   padding: "40px", // increases clickable area
            //   width: "50px", // optional fixed width
            //   height: "45px",
            // }}
          >
            {/* <ArrowBackIcon
              sx={{
                fontSize: {
                  xs: "20px",
                  sm: "24px",
                  md: "30px", // icon size increase
                },
              }}
            /> */}
            <KeyboardBackspaceIcon sx={{ fontSize: 30, color: "#01008B" }} />
          </IconButton>

          <Grid
            item
            xs={12}
            sm={10}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              mt: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{
                xs: "12px",
                sm: "13px",
                md: "20px",
              }}
            >
              White Label Enquiries
            </Typography>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12} sx={{ p: 0 }}>
            <Typography
              variant="h6"
              sx={{
                color: "#01008B",
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "24px",
                },
                fontWeight: 600,
              }}
            >
              {enquiries.productName}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ p: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#01008B",
                  fontSize: {
                    xs: "12px",
                    sm: "13px",
                    md: "15px",
                  },
                  fontWeight: 500,
                }}
              >
                course id - {enquiries.productId}
              </Typography>
              <Typography
                sx={{
                  color: "#01008B",
                  fontSize: {
                    xs: "13px",
                    sm: "16px",
                    md: "20px",
                  },
                  fontWeight: 500,
                }}
              >
                Total Enquiries - {totalEnquiry}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            backgroundColor: "white",
            px: 2,
            py: 2,
            mt: 2,
            borderRadius: "12px",
            overflow: "auto",
            height: "75vh",
          }}
        >
          <Box sx={{ minWidth: {lg:"1350px", md:'1200px', sm:'1200px', xs:'1100px'} }}>
            {/* HEADER */}
            <Box
              sx={{
                ...tableGrid,
                borderBottom: "1.5px solid black",
                p: "10px",
              }}
            >
              <Box sx={{ ...label, color: "#01008B", fontWeight: 500 }}>
                Date of Enquiry
              </Box>

              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Name
              </Box>

              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Mobile No.
              </Box>

              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Email Id
              </Box>

              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Address
              </Box>
              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              ></Box>
              <Box />
            </Box>

            {/* DATA ROW */}
            {enquiry?.map((enq, index) => {
              return (
                <Box
                  sx={{
                    ...tableGrid,
                    backgroundColor: "#E8E8FF",
                    borderRadius: "8px",
                    mt: 1,
                    mb: 1,
                    p: 1, // 👈 padding on row, not inner items

                    width: "fit-content",
                  }}
                >
                  <Box sx={{ ...label, px: 2, fontWeight: "medium" }}>
                    {formatDate(enq?.appliedDate) || "-"}
                  </Box>

                  <Box
                    sx={{ ...label, textAlign: "center", fontWeight: "medium" }}
                  >
                    {enq?.userName || "-"}
                  </Box>

                  <Box sx={{ ...label, textAlign: "center" }}>
                    {enq?.userMobile || "-"} {/* {mobileNumber && ( */}
                    <IconButton
                      size="small"
                      sx={{ p: 0 }}
                      onClick={() =>
                        window.open(
                          `https://web.whatsapp.com/send?phone=${enq?.userMobile}`,
                          "_blank",
                        )
                      }
                    >
                      <WhatsAppIcon
                        sx={{
                          color: "white",
                          fontSize: 20,
                          borderRadius: "50%",
                          backgroundColor: "#25D366",
                          p: "3px",
                        }}
                      />
                    </IconButton>
                    {/* )} */}
                  </Box>

                  <Box
                    sx={{ ...label, fontWeight: "medium", textAlign: "center" }}
                  >
                    {enq?.userEmail || "-"}
                  </Box>

                  <Box
                    sx={{ ...label, textAlign: "center", fontWeight: "medium" }}
                  >
                    {enq?.userAddress || "-"}
                  </Box>

                  <Box
                    sx={{ ...label, textAlign: "center", fontWeight: "medium" }}
                  >
                    <Button
                      onClick={() => {
                        setModalData(enq);
                        setOpen(true);
                      }}
                      variant="contained"
                      sx={{
                        ...label,
                        px: { xl: 4, lg: 3, md: 3, sm: 3, xs: 3 },
                      }}
                      startIcon={
                        <Box
                          component="img"
                          src={details} // details should be the path to your image
                          alt="details"
                          sx={{
                            width: { lg: 20, md: 16, sm: 18, xs: 15 },
                            height: { lg: 20, md: 16, sm: 18, xs: 15 },
                          }}
                        />
                      }
                    >
                      Details
                    </Button>
                  </Box>
                </Box>
              );
            })}
          </Box>

          <CandidateInformation
            modalData={modalData}
            applied={true}
            open={open}
            setOpen={setOpen}
            getRecept={() => {
              // getPaymentRec({ ...getPaymentObj });
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default Enquiries;
